import React from "react"
import { Router /* Location */ } from "@reach/router"
// import posed, { PoseGroup } from 'react-pose'

// const NavigateTransition = posed.div({
//   enter: { opacity: 1, transition: { duration: 300, beforeChildren: 600 } },
//   exit: { opacity: 0 }
// })

// const PosedRouter = ({ children, withParent = true, ...rest }) => (
//   <Location>
//     {({ location }) => (
//       <PoseGroup>
//         <NavigateTransition key={location.key} withParent={withParent}>
//           <Router location={location}>{children}</Router>
//         </NavigateTransition>
//       </PoseGroup>
//     )}
//   </Location>
// )

interface RouterProps {
  children: React.ReactNode
}

const PosedRouter: React.SFC<RouterProps> = ({ children }) => <Router>{children}</Router>

export default PosedRouter
